import { isCustomizableMeal, Product } from 'lib/product';
import { ProductStructuredData } from 'lib/productSEO';
import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import * as analytics from 'lib/analytics';
import ProductMediaGallery from './ProductMediaGallery';
import ProductDetail from './ProductDetail';
import { ProductCustomizationContextProvider } from 'lib/sellingProduct/ProductCustomizationContext';
import InitialProductVariantSetterSuspense from 'lib/sellingProduct/InitialProductVariantSetterSuspense';
import ProductActions from './ProductActions';
import TabContents from 'lib/sellingProduct/TabContents';

const ProductViewDialog = ({
  product,
  onClose,
  initialAddonOptions,
  onFirstTimeAdded,
}: {
  product: Product | null;
  onClose: (product: Product) => void;
  initialAddonOptions?: Record<number, number>;
  onFirstTimeAdded?: () => void;
}) => {
  useEffect(() => {
    if (product) {
      if (isCustomizableMeal(product)) {
        analytics.customizeMeal({ product });
      } else {
        analytics.quickViewProduct({ product });
      }
    }
  }, [product]);

  if (!product) return null;

  return (
    <>
      <Modal
        show={product !== null}
        onHide={onClose}
        size="xl"
        centered
        contentClassName="tw-h-full"
        scrollable
        dialogClassName="tw-pr-0"
      >
        <button
          title="Close (Esc)"
          type="button"
          className="mfp-close tw-absolute tw-top-4 tw-right-4 lg:tw-right-8"
          onClick={() => onClose(product)}
        >
          <span>×</span>
        </button>
        <ProductCustomizationContextProvider
          initialSelectedAddons={initialAddonOptions}
        >
          {/* @ts-ignore */}
          <ProductStructuredData product={product} />
          <InitialProductVariantSetterSuspense
            product={product}
            fallback="Loading..."
          >
            <div className="tw-flex tw-flex-col tw-h-full">
              <Modal.Body className="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden tw-p-4 lg:tw-mt-4 md:tw-p-8 no-scrollbar">
                <div className="tw-flex tw-flex-col">
                  <div className="tw-grid md:tw-grid-cols-2 tw-gap-4 md:tw-gap-8">
                    <div>
                      <ProductMediaGallery product={product} />
                    </div>
                    <ProductDetail
                      product={product}
                      onAddToCart={() => onClose(product)}
                      onFirstTimeAdded={onFirstTimeAdded}
                      isQuickView
                    />
                  </div>
                  <TabContents
                    productId={product.id}
                    data={product.tab_contents}
                    className="tw-mb-0 tw-mt-8"
                  />
                </div>
              </Modal.Body>
              <Modal.Footer className="tw-sticky tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-z-10 tw-p-0">
                <ProductActions
                  product={product}
                  onAddToCart={() => onClose(product)}
                  onFirstItemAdded={onFirstTimeAdded}
                />
              </Modal.Footer>
            </div>
          </InitialProductVariantSetterSuspense>
        </ProductCustomizationContextProvider>
      </Modal>
    </>
  );
};

export default ProductViewDialog;
